import { z } from 'zod';

import { FlexModificationWorkoutPlan } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CreateWorkoutPlanFlexModEvent = BaseLoanEvent.extend({
  type: z.literal('createWorkoutPlanFlexMod'),
  data: FlexModificationWorkoutPlan.pick({
    reason: true,
    trialTermMonths: true,
    evaluationNoticeSentDate: true,
    modification: true,
    workflowInformation: true,
  }).extend({
    startDate: z.date(),
    quotedTrialPITI: z.number(), // verify the quoted trial payment is not stale on submission
  }),
});
export type CreateWorkoutPlanFlexModEvent = z.infer<typeof CreateWorkoutPlanFlexModEvent>;
